export default __webpack_public_path__ + "static/media/logo_spwn.ba8f35f4.svg";